<template>
    <div class="card shadow-sm overflow-hidden"
         v-if="isVisible">
        <div class="card-header d-flex align-items-center py-1 px-2">
            <div class="flex-grow-1">
                <strong>考察狀態</strong>
            </div>
        </div>
        <div class="card-body p-2">
            <form v-on:submit.prevent.stop="confirm">
                <b-form-file class="mb-2"
                             multiple
                             required
                             placeholder="請選擇考察文件"
                             v-bind:disabled="!isInteractive"
                             v-model="attachments">
                </b-form-file>
                <button class="btn btn-sm btn-block btn-light border"
                        type="submit"
                        v-if="isInteractive"
                        v-bind:class="{ 'btn-loading': isLoading, 'mb-3': reply && Array.isArray(reply) && reply.length > 0, }">
                    📤 確認及上傳
                </button>

                <ul class="list-group"
                    v-if="reply">
                    <li class="list-group-item d-flex justify-content-between align-items-center pl-3 pr-2 py-2"
                        v-for="{ filename, originalname, } in reply"
                        v-bind:key="filename">
                        <span>
                            <a target="_blank"
                               v-bind:alt="originalname"
                               v-bind:download="originalname"
                               v-bind:href="`https://api.339home.com/v1.0/task/${ taskId }/file/${ filename }`">
                                {{ originalname }}
                            </a>
                        </span>
                        <div>
                            <button class="btn btn-sm btn-danger"
                                    v-on:click.prevent.stop="deleteFile(filename)">
                                🗑️
                            </button>
                        </div>
                    </li>
                </ul>
            </form>
        </div>
    </div>
</template>

<script>
const TaskStageVisibilityMap = new Map(
    [
        ["5ed2f24c5dafc6343ed2aa2d", false],
        ["5ed2f3d352a8f2d15a1f7a67", false],
        ["5ed2f41552a8f2d15a1f7a69", true],
        ["5ed308b127cb2d7684bc3423", true],
        ["5ed309638132e677e36b6e48", true],
        ["5ed30bf79594587e7a8d2178", true],
        ["6000fe508d65ee9ddee9f77f", true],
        ["6000fe658d65ee9ddee9f780", true],
        ["6000fe6c8d65ee9ddee9f781", false],
        ["6000fe738d65ee9ddee9f782", false],
    ]
);

const TaskStageInteractivityMap = new Map(
    [
        ["5ed2f24c5dafc6343ed2aa2d", false],
        ["5ed2f3d352a8f2d15a1f7a67", false],
        ["5ed2f41552a8f2d15a1f7a69", true],
        ["5ed308b127cb2d7684bc3423", false],
        ["5ed309638132e677e36b6e48", false],
        ["5ed30bf79594587e7a8d2178", false],
        ["6000fe508d65ee9ddee9f77f", false],
        ["6000fe658d65ee9ddee9f780", false],
        ["6000fe6c8d65ee9ddee9f781", false],
        ["6000fe738d65ee9ddee9f782", false],
    ]
);

import { BFormFile, } from "bootstrap-vue";

export default {
    name: "TaskInspect",
    components: {
        BFormFile,
    },
    props: {
        stage: {
            type: String,
        },
        response: {
            type: Object,
        },
    },
    data () {
        return {
            isLoading: false,
            attachments: null,
        };
    },
    computed: {
        taskId () {
            return this.$route.params.taskId;
        },
        isVisible () {
            return TaskStageVisibilityMap.get(this.stage);
        },
        isInteractive () {
            return TaskStageInteractivityMap.get(this.stage);
        },
        reply () {
            return this.response["inspect"] ?? "";
        },
    },
    methods: {
        async confirm () {
            const { taskId, attachments, } = this;
            this.isLoading = true;
            try {
                await this.$store.dispatch(
                    "tasks/inspect",
                    { taskId, attachments, }
                );
            } catch (e) {
                console.error(e);
            }
            this.isLoading = false;
            this.attachments = null;
        },
        async deleteFile (fileId) {
            const { taskId, } = this;
            this.isLoading = true;
            try {
                await this.$store.dispatch(
                    "tasks/deleteFile",
                    { taskId, fileId, }
                );
            } catch (e) {
                console.error(e);
            }
            this.isLoading = false;
        },
    },
}
</script>

<style lang="scss" scoped>
.card-header {
    font-size: 0.9rem;
}
</style>
